module.exports = __webpack_public_path__ + "media/fonts/Oricons-537ab42021d2f607b72b22b1b65bac20.ttf";